import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import FadeUp from "../UI/FadeUp";
import "swiper/css";
import "swiper/css/free-mode";
import "./CategorySlider.css";

const categories = [
  { id: 1, name: "All", image: "https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 2, name: "Pizza", image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 3, name: "Burger", image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 4, name: "Noodles", image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 5, name: "Salads", image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 6, name: "Chicken", image: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 7, name: "Sushi", image: "https://images.unsplash.com/photo-1579871494447-9811cf80d66c?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
  { id: 8, name: "Drinks", image: "https://images.unsplash.com/photo-1544145945-f90425340c7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" },
];

const CategorySlider = ({ onSelectCategory }) => {
  const [activeId, setActiveId] = useState(1);

  const handleSelect = (cat) => {
    setActiveId(cat.id);
    if (onSelectCategory) {
      onSelectCategory(cat.name);
    }
  };

  return (
    <section className="category-section">
      <div className="category-container">
        <FadeUp>
          <h2 className="section-title">What are you craving?</h2>
        </FadeUp>

        <FadeUp delay={0.2}>
          <Swiper
            slidesPerView="auto"
            spaceBetween={16}
            freeMode={true}
            grabCursor={true}
            modules={[FreeMode]}
            className="category-swiper"
          >
            {categories.map((cat) => (
              <SwiperSlide key={cat.id}>
                <div 
                  className={`category-card ${activeId === cat.id ? "active" : ""}`}
                  onClick={() => handleSelect(cat)}
                >
                  <div className="category-image-wrapper">
                    <img src={cat.image} alt={cat.name} className="category-image" />
                  </div>
                  <span className="category-name">{cat.name}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </FadeUp>
      </div>
    </section>
  );
};

export default CategorySlider;
